export enum DocumentStatus {
  NEW = 'NEW',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  UPLOADED = 'UPLOADED',
}

export enum PropertyLocationType {
  SINGLE_FAMILY_HOME = 'SINGLE_FAMILY_HOME',
  TOWNHOUSE = 'TOWNHOUSE',
  CONDO = 'CONDO',
  MULTI_UNIT = 'MULTI_UNIT',
  COMMERCIAL = 'COMMERCIAL',
  ACCESSORY_DWELLING_UNIT = 'ACCESSORY_DWELLING_UNIT',
  OTHER = 'OTHER',
}

export enum ContactPrivacyType {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}

export enum ContactRole {
  TENANT = 'TENANT',
  LANDLORD = 'LANDLORD',
  PROPERTY_MANAGER = 'PROPERTY_MANAGER',
  OWNER_REPRESENTATIVE = 'OWNER_REPRESENTATIVE',

  CLEANING_SERVICE = 'CLEANING_SERVICE',
  HVAC_CONTRACTOR = 'HVAC_CONTRACTOR',
  ELECTRIC_PROVIDER = 'ELECTRIC_PROVIDER',
  WATER_PROVIDER = 'WATER_PROVIDER',
  WASTEWATER_SERVICE = 'WASTEWATER_SERVICE',
  PROPANE_SUPPLIER = 'PROPANE_SUPPLIER',
  TRASH_REMOVAL = 'TRASH_REMOVAL',
  TREE_SERVICE = 'TREE_SERVICE',
  PEST_CONTROL = 'PEST_CONTROL',
  POOL_SERVICE = 'POOL_SERVICE',
  LAWN_CARE = 'LAWN_CARE',
  LANDSCAPING_VENDOR = 'LANDSCAPING_VENDOR',
  SECURITY_PROVIDER = 'SECURITY_PROVIDER',
  SOUND_SYSTEM_VENDOR = 'SOUND_SYSTEM_VENDOR',
  WATER_COOLER_VENDOR = 'WATER_COOLER_VENDOR',

  TAX_AUTHORITY = 'TAX_AUTHORITY',
  INSURANCE_AGENT = 'INSURANCE_AGENT',
  LEGAL_REPRESENTATIVE = 'LEGAL_REPRESENTATIVE',

  OTHER = 'OTHER',
}

export enum PropertyLocationDeclaredUnitsCount {
  FROM_1_TO_5 = 'FROM_1_TO_5',
  FROM_6_TO_25 = 'FROM_6_TO_25',
  FROM_26_TO_100 = 'FROM_26_TO_100',
  FROM_101_TO_500 = 'FROM_101_TO_500',
  ABOVE_500 = 'ABOVE_500',
}

export enum PropertyManagementRole {
  VENDOR = 'VENDOR',
  MANAGER = 'MANAGER',
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
  VIEWER = 'VIEWER',
}

export enum MessageStatus {
  needs_response = 'needs_response',
  waiting_for_customer = 'waiting_for_customer',
  investigating = 'investigating',
  done = 'done',
}
